<script lang="ts">
    import { recordsCitationService } from "../services";
    import { dateInputFormatter } from "../services/Functions";
    import type { RegisterCitation } from "../Model/RegisterCitation";
    import RegisterModalCitation from "./RegisterModalCitation.svelte";

    export let third_id: string;
    let editRegister = null;

    let registers: any[];

    $: loadRegisters()

    async function loadRegisters(): Promise<void> {

        registers = await recordsCitationService.getRecordsByThird(third_id);

        registers.sort((a,b) => {
        return a.inRegistNumber < b.inRegistNumber ? -1 : 1;
         })
        
    }

    function registerUpdate(register: RegisterCitation): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

</script>

<style>
</style>

{#if registers}
    <div class="row mt-3">
        <div class="col-12">
            {#if registers?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Entrada</th>
                            <th scope="col">Fecha Entrada</th>
                            <th scope="col">Salida</th>
                            <th scope='col'>Fecha Salida</th>
                            <th scope="col">Tipo</th>
                        </tr>
                </thead>
                <tbody>
                    {#each registers as register, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                {#if register.inRegistNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.inRegistNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.inDate}
                                    {dateInputFormatter(register.inDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.outRegistNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.outRegistNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outDate}
                                    {dateInputFormatter(register.outDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.contentInfo}
                                    {#if register.contentInfo == 'NULL'}
                                        <span></span>
                                    {:else}
                                        {register.contentInfo}
                                    {/if}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h4>No hay registros para mostrar</h4>
                </div>
            {/if}
        </div>
    </div>
{/if}

<RegisterModalCitation bind:register={editRegister}  on:registerUpdate={() => registerUpdate(editRegister)}/>